import { render } from "./TrainingsLanding.vue?vue&type=template&id=a2abd6d8&scoped=true"
import script from "./TrainingsLanding.vue?vue&type=script&lang=js"
export * from "./TrainingsLanding.vue?vue&type=script&lang=js"

import "./TrainingsLanding.vue?vue&type=style&index=0&id=a2abd6d8&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2abd6d8"]])

export default __exports__